module.exports = __webpack_public_path__ + "static/media/add.c113cb29.svg";